import { Element } from "@js/extends";

import Swiper from "swiper/bundle";
import "swiper/css/bundle";

export default class Slider extends Element {
	mounted() {
		this.slider = this.el;
		this.viewport = this.slider.querySelector(".js-slider-viewport");
		this.nextButton = this.slider.querySelector(".js-slider-next-button");
		this.prevButton = this.slider.querySelector(".js-slider-prev-button");

		this.initSlider();
	}

	initSlider() {
		this.swiper = new Swiper(this.viewport, {
			init: false,
			slidesPerView: 1,
			slidesPerGroup: 1,
			spaceBetween: 16,
			speed: 400,
			autoHeight: false,
			a11y: {
				slideRole: "",
			},
			navigation: {
				nextEl: this.nextButton,
				prevEl: this.prevButton,
			},
			breakpoints: {
				480: {
					slidesPerView: 2,
					slidesPerGroup: 2,
					speed: 500,
				},
				680: {
					slidesPerView: 3,
					slidesPerGroup: 3,
					speed: 600,
				},
				992: {
					slidesPerView: 4,
					slidesPerGroup: 4,
					speed: 700,
				},
			},
			on: {
				init: () => {
					this.setEqualSlideHeights(this.swiper);
				},
				resize: () => {
					this.setEqualSlideHeights(this.swiper);
				},
			},
		});

		this.swiper.init();
	}

	setEqualSlideHeights(slider) {
		if (!slider || !slider.slides || !slider.slides.length) return;

		let maxHeight = 0;

		slider.slides.forEach((slide) => {
			slide.style.height = "auto";
			maxHeight = Math.max(maxHeight, slide.offsetHeight);
		});

		slider.slides.forEach((slide) => {
			slide.style.height = `${maxHeight}px`;
		});
	}
}
